import React, { useEffect, useState } from "react";
import { Container, Segment, Grid } from "semantic-ui-react";
import colormap from "colormap";

import { DataContext } from "../context/DataContext";
import { Segmentation } from "./Segmentation";
import { Caption } from "./Caption";

export const Dataset = (props) => {
  const [data, setData, animation, setAnimation] = useState({
    image_id: "",
    segments: [],
    index: 0,
    segment_colors: {},
    ann_index: -1,
  });

  const fetchData = () => {
    fetch(
      "https://lambda004.uniandes.edu.co/panoptic-narrative-grounding/api/ids.json"
    ).then((response) => {
      response.json().then((ids) => {
        let ann_index = data.ann_index + 1;
        // let id = ids[ann_index];
        let id = ids[(Math.random() * ids.length) | 0];
        fetch(
          `https://lambda004.uniandes.edu.co/panoptic-narrative-grounding/api/annotations/${id}.json`
        ).then((response) => {
          response.json().then((data) => {
            let num_nouns =
              data.segments[0].noun === true
                ? Math.ceil(data.segments.length / 2)
                : Math.floor(data.segments.length / 2);
            let colors = colormap({
              colormap: "hsv",
              nshades: num_nouns >= 11 ? num_nouns : 11,
              format: "rgba",
              alpha: 0.78,
            });
            let segment_colors = {};
            for (let i = 0; i < data.segments.length; i++) {
              if (data.segments[i].noun === true) {
                data.segments[i].segment_ids.forEach((s) => {
                  segment_colors[s] = colors[Math.floor(i / 2)];
                });
              }
            }
            let colors_hex = colormap({
              colormap: "hsv",
              nshades: num_nouns >= 11 ? num_nouns : 11,
              format: "hex",
              alpha: 1,
            });
            setData({
              ...data,
              index: null,
              segment_colors: segment_colors,
              colors_rgba: colors,
              colors: colors_hex,
              segment: null,
              num_nouns: num_nouns,
              animation: null,
              playing: false,
              ann_index: ann_index,
            });
          });
        });
      });
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <DataContext.Provider value={{ data, setData, animation, setAnimation }}>
      <Segment id="dataset" vertical padded="very">
        <Container textAlign="center">
          <Grid columns="equal" celled="internally" stackable>
            <Grid.Row>
              <Grid.Column>
                <Segmentation data={data} />
              </Grid.Column>
              <Grid.Column>
                <Caption segments={data.segments} fetchData={fetchData} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Segment>
    </DataContext.Provider>
  );
};
